import { Phone } from "lucide-react";
import { Reveal } from "./Reveal";
import { IMAGES, PHONE_DISPLAY, PHONE_TEL } from "@/site";

export const EmergencyCTA = () => (
    <section data-testid="emergency-cta" className="relative overflow-hidden">
        <img src={IMAGES.emergency} alt="" aria-hidden="true" loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-navy-950/92" />
        <div className="relative mx-auto flex w-full max-w-7xl flex-col gap-10 px-5 py-20 sm:px-8 sm:py-24 lg:flex-row lg:items-center lg:justify-between lg:py-28">
            <div className="max-w-2xl">
                <Reveal>
                    <p className="flex items-center gap-3 text-xs font-bold uppercase tracking-[0.28em] text-gold">
                        <span className="h-px w-8 bg-gold" />
                        Emergency Service
                    </p>
                </Reveal>
                <Reveal delay={0.08}>
                    <h2 data-testid="emergency-heading" className="mt-4 font-display text-3xl font-semibold leading-[1.08] tracking-tight text-white sm:text-4xl lg:text-[2.75rem]">
                        Locked Out? Don't Stress. <span className="italic text-gold">We're Here 24/7.</span>
                    </h2>
                </Reveal>
                <Reveal delay={0.16}>
                    <p className="mt-5 text-base leading-relaxed text-slate-300">
                        Whether you're standing outside your home, locked out of your vehicle, or dealing with a broken
                        lock at your business, give us a call. We'll help you understand your options and get you back
                        on your way.
                    </p>
                </Reveal>
            </div>
            <Reveal delay={0.2} className="shrink-0">
                <div className="flex flex-col items-start gap-4">
                    <a
                        data-testid="emergency-call-button"
                        href={PHONE_TEL}
                        className="inline-flex items-center gap-3 rounded-full bg-gold px-10 py-5 text-base font-extrabold uppercase tracking-wider text-navy-950 shadow-2xl shadow-gold/30 transition-[transform,background-color] duration-300 hover:-translate-y-1 hover:bg-gold-light"
                    >
                        <Phone className="h-5 w-5" />
                        Call Now — {PHONE_DISPLAY}
                    </a>
                    <p className="text-sm font-semibold uppercase tracking-[0.18em] text-slate-400">
                        24/7 Emergency Locksmith Service
                    </p>
                </div>
            </Reveal>
        </div>
    </section>
);
